import { DepartmentParentPicker } from './DepartmentParentPicker'
import type { Department } from '../../types/department'

type DepartmentPickerProps = {
  tree: Department[]
  value: string
  onChange: (departmentId: string) => void
  /** Signup and case forms require a pick; admin parent selectors may allow clearing. */
  required?: boolean
  placeholder?: string
  disabled?: boolean
  excludedIds?: Set<string>
}

/**
 * Shared department tree dropdown (doctor signup + case forms).
 * Same hover-flyout UX as DepartmentParentPicker.
 */
export function DepartmentPicker({
  tree,
  value,
  onChange,
  required = false,
  placeholder = 'Select department',
  disabled = false,
  excludedIds,
}: DepartmentPickerProps) {
  return (
    <DepartmentParentPicker
      tree={tree}
      value={value}
      onChange={onChange}
      excludedIds={excludedIds}
      showNoneOption={!required}
      placeholder={placeholder}
      noneLabel={required ? undefined : 'None'}
      disabled={disabled}
    />
  )
}
